import {
  QuerySupplierOfficesOrderByColumn,
  QueryVehiclesOrderByColumn,
  SortOrder,
  SupplierOfficeListQueryVariables,
} from "@/gql/graphql";

export function getImportOfficeQueryVariables(
  supplierId: string,
): SupplierOfficeListQueryVariables {
  return {
    page: 1,
    first: 200,
    supplier_id: supplierId,
    archived: false,
    orderBy: [
      {
        order: SortOrder.Asc,
        column: QuerySupplierOfficesOrderByColumn.Code,
      },
    ],
  };
}

export function getImportVehicleQueryVariables(supplierId: string) {
  return {
    page: 1,
    first: 200,
    supplier_id: supplierId,
    archived: false,
    orderBy: [
      {
        order: SortOrder.Asc,
        column: QueryVehiclesOrderByColumn.Code,
      },
    ],
  };
}
